import React from "react";
import { bool, object } from "prop-types";
import { WithLazy } from "@quintype/components";
import CardImage from "../../../atoms/cardimage";
import { Link } from "@quintype/components";

import "./hero-image.m.css";

const HeroImage = ({ story, aspectRatio, imageType ,newBlock = false , inStory = true }) => {
  if (!story["hero-image-s3-key"]) {
    return null;
  }

  const heroImageContent = (
    <div styleName={`hero-image ${newBlock && !inStory ? "newBlock-hero-image" : ""}`} className="hero-image">
      {story?.["hero-image-hyperlink"] ? (
        <Link href={story?.["hero-image-hyperlink"]}>
          <CardImage
            story={story}
            showMetaData={false}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[400, 900]}
            sizes="(max-width: 1024px) 25vw, 100vw"
            showAlternateImage
            showCameraIcon={false}
            showVideoIcon={true}
            eager={inStory}
            loading={inStory ? "eager" : "lazy"}
            fetchpriority={inStory ? "high" : undefined}
            defaultWidth={400}
          />
        </Link>
      ) : (
        <CardImage
          story={story}
          showMetaData={false}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={[400, 900]}
          sizes="(max-width: 1024px) 25vw, 100vw"
          showAlternateImage
          showCameraIcon={false}
          showVideoIcon={true}
          eager={inStory}
          loading={inStory ? "eager" : "lazy"}
          fetchpriority={inStory ? "high" : undefined}
          defaultWidth={400}
        />
      )}
      {(story["hero-image-caption"] || story["hero-image-attribution"]) && (
        <div styleName={`caption-container ${newBlock && !inStory ? "newBlock" : ""}`}>
          {story["hero-image-caption"] && (
            <figcaption styleName={`caption`} dangerouslySetInnerHTML={{ __html: story["hero-image-caption"] }} />
          )}
          {story["hero-image-attribution"] && (
            <span
              styleName={`attribute`}
              dangerouslySetInnerHTML={{ __html: `${story["hero-image-attribution"]}` }}
            />
          )}
        </div>
      )}
    </div>
  );

  if (inStory) {
    return heroImageContent;
  }

  return (
    <WithLazy margin="20px">
      {() => heroImageContent}
    </WithLazy>
  );
};
HeroImage.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9"
};

HeroImage.propTypes = {
  story: object,
  newBlock: bool,
  inStory: bool
};

export default HeroImage;
